import { ArrowRight2 } from "iconsax-react";
import { Button } from "@/shared/ui";

interface SectionCardProps {
  title: string;
  subtitle?: string;
  link?: string;
  onLinkClick?: () => void;
  children: React.ReactNode;
}

export default function SectionCard({ title, subtitle, link, onLinkClick, children }: SectionCardProps) {
  return (
    <div className="radius-3xl surface-base-fill px-6 pt-5 pb-5">
      <div className="flex justify-between items-center gap-4 mb-5">
        <div className="flex flex-col gap-0.5">
          <h3 className="text-body-bold-md content-base-primary">{title}</h3>
          {subtitle && <p className="text-body-regular-sm content-base-secondary">{subtitle}</p>}
        </div>
        {link && (
          <Button
            link={onLinkClick ? undefined : link}
            onClick={onLinkClick}
            variant="secondary"
            isIconButton
            className="w-5! h-5! p-0! rounded-sm! flex items-center justify-center content-base-primary">
            <ArrowRight2 size={12} color="currentColor" />
          </Button>
        )}
      </div>
      {children}
    </div>
  );
}
